import { OrganisationTypeConstants } from "../../../../constants";
import { AssetManagerSingleCardWithTabsTemplate } from "../../../../templates";
import { getOperationsDealWorkflowsRoute, getOperationsDeliveryWorkflowsRoute } from "../../../../utils/routes";

const Workflows = (): JSX.Element => {
  return (
    <AssetManagerSingleCardWithTabsTemplate
      activeElement="Operations"
      pageTitle="Workflows"
      tabsList={[
        {
          label: "Deal workflows",
          route: getOperationsDealWorkflowsRoute(OrganisationTypeConstants.ASSET_MANAGER),
        },
        {
          label: "Delivery workflows",
          route: getOperationsDeliveryWorkflowsRoute(OrganisationTypeConstants.ASSET_MANAGER),
        },
      ]}
      hasBackground={false}
    />
  );
};

export default Workflows;
